// extracted by mini-css-extract-plugin
export default {"preloader":"styles_preloader__JPHRB","spinner":"styles_spinner__mbeyk","spin":"styles_spin__2BnyF"};